/*
  本人確認マスタデータストア
*/
const getDefaultState = () => {
  return {
    /*************************
     * 汎用区分マスタ
     *************************/
    // 申請書類区分
    // ex {cd: "10", name: "運転免許証"}
    appDocKbnList: [],
    // 申請書類詳細区分
    // ex {cd: "10", name: "表面"}
    docDetailKbnList: [],
    // // 性別区分
    // docSexKbnList: [{ cd: "F", name: "女性" }, { cd: "M", name: "男性" }],
    // 確認状態区分
    // ex {cd: "10", name: "申請待ち", nameAbbrv: "申請待", colorName: "light-blue lighten-1", icon: "mdi-card-account-details-outline"}
    verifyStatusKbnList: [],
    // 処置区分
    // ex {cd: "10", name: "承認"}
    verifyDealKbnList: [],
  };
};

/**
 * ステート
 */
const state = getDefaultState();

/**
 * ゲッター
 */
const getters = {
  /*
   *  汎用区分マスター(申請書類区分)取得
   */
  getAppDocKbnList(state) {
    return state.appDocKbnList;
  },
  /*
   *  汎用区分マスター(申請書類詳細区分)取得
   */
  getDocDetailKbnList(state) {
    return state.docDetailKbnList;
  },
  /*
   *  汎用区分マスター(性別区分)取得
   */
  getDocSexKbnList(state) {
    return state.docSexKbnList;
  },
  /*
   *  汎用区分マスター(確認状態区分)取得
   */
  getVerifyStatusKbnList(state) {
    return state.verifyStatusKbnList;
  },
  /*
   *  汎用区分マスター(処置区分)取得
   */
  getVerifyDealKbnList(state) {
    return state.verifyDealKbnList;
  },
  
};

/**
 * ミューテーション
 */
const mutations = {
  appDocKbnList(state, status) {
    state.appDocKbnList = status;
  },
  docDetailKbnList(state, status) {
    state.docDetailKbnList = status;
  },
  docSexKbnList(state, status) {
    state.docSexKbnList = status;
  },
  verifyStatusKbnList(state, status) {
    state.verifyStatusKbnList = status;
  },
  verifyDealKbnList(state, status) {
    state.verifyDealKbnList = status;
  },
  /**
   * state初期化
   * @param {ストア}} state
   */
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};

/**
 * アクション
 */
const actions = {
  setAppDocKbnList(context, info) {
    context.commit("appDocKbnList", info);
  },
  setDocDetailKbnList(context, info) {
    context.commit("docDetailKbnList", info);
  },
  setDocSexKbnList(context, info) {
    context.commit("docSexKbnList", info);
  },
  setVerifyStatusKbnList(context, info) {
    context.commit("verifyStatusKbnList", info);
  },
  setVerifyDealKbnList(context, info) {
    context.commit("verifyDealKbnList", info);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
